import { FolderSharingKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetFolderSharingsRequest, GetFolderSharingsResponse } from "@maven-rest/docs/FolderSharing.dto";
import { FolderSharingUrl } from "@maven-rest/docs/FolderSharing.url";

export function useFolderSharingsQuery(
  req: GetFolderSharingsRequest,
  options?: SimpleQueryOptions<GetFolderSharingsResponse, GetFolderSharingsRequest>
) {
  return useBaseQuery({
    queryKey: [FolderSharingKey.FolderSharings, String(req.organizationId), String(req.folderId), String(req.fileId)],
    fnOption: {
      url: FolderSharingUrl.getFolderSharings,
      request: req,
    },
    ...options,
  });
}
